import React, { useMemo, useState } from "react";
import { colors, css, fonts } from "../../Styles";
import { NewButtonList, AnimalNumberDisplay, FeedCurveWithLabels, TenDaysGraphComponents } from "../";
import { ButtonTypes } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { Animal } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";

interface animalFeedView_Props {
  activeAnimal: Animal;
  feedCurve: any;
}

export default function AnimalFeedView({ activeAnimal, feedCurve }:animalFeedView_Props) {
  const { t } = useTranslation()
  const [currentFeedview, setCurrentFeedview] = useState<"LAST10DAYS" | "FEEDCURVE">("FEEDCURVE");

  // FeedCurve
  const FeedCurve: JSX.Element = useMemo(() => {

    if (!feedCurve) return (
      <p style={{ ...css.emptyPen }}>
        {t("animalPages.animal.noFeedCurve", {defaultValue: "No Feed Curve Found"})}
      </p>
    )
    
    return (
      <FeedCurveWithLabels data={feedCurve} />
    )
  }, [feedCurve, t])

  // Last10Days
  const Last10Days: JSX.Element = useMemo(() => {
    // const last10Days = activeAnimal.lastTenDay 

    if (!activeAnimal) return (
      <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary }}>
        {t("animalPages.animal.noFeedCurve", {defaultValue: "No Feed Curve Found"})}
      </p>
    )

    return (
      <TenDaysGraphComponents data={[activeAnimal]} />
    )
  }, [activeAnimal, t])
  
  // #region | Feed View State Router
  const FeedviewStateRouter = () => {
    switch (currentFeedview) {
      case "LAST10DAYS":
        return (
          <>{Last10Days}</>
        );
      case "FEEDCURVE":
        return (
          <>{FeedCurve}</>
        );
      default:
        return null;
    }
  }
  // #endregion
  
  return (<div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
    <AnimalNumberDisplay
      header={t("", { defaultValue: "Info for" })}
      content={activeAnimal.animal_id}
    />
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "0px 10px", borderTop: "1px solid " + colors.greyTertiary, borderBottom: "1px solid " + colors.greyTertiary, height: "40px", marginTop: "5px" }}>
      <NewButtonList
        contents={[
          t("animalPages.animal.feedCurve", {defaultValue: "Feed Curve"}),
          t("feed.general.feedLastDays", { defaultValue: "last 10 days" }),
        ]}
        onClick={(i) => {
          if (i === 0) {setCurrentFeedview("FEEDCURVE")}
          if (i === 1) {setCurrentFeedview("LAST10DAYS")}
        }}
        buttonType={ButtonTypes.textButton}
        listOverrides={{
          listGap: "5px"
        }}
        overrides={(index: number) => ({
          baseStyles: {
            backgroundColor: (currentFeedview === "FEEDCURVE" && index === 0) || (currentFeedview === "LAST10DAYS" && index === 1) ? colors.greyDarkPrimary : colors.transparent,
            padding: "8px 10px",
            borderRadius: "10px"
          },
          hoverStyles: {
            opacity: (currentFeedview === "FEEDCURVE" && index === 0) || (currentFeedview === "LAST10DAYS" && index === 1) ? 1 : 0.5,
          },
          contentStyles: {
            color: (currentFeedview === "FEEDCURVE" && index === 0) || (currentFeedview === "LAST10DAYS" && index === 1) ? colors.greyLightTertiary : colors.greyDarkPrimary,
          }
        })}
      />
    </div>
    <div style={{ marginTop: "10px" }}>
      {FeedviewStateRouter()}
    </div> 
  </div>)
}